import React from 'react';
import { Segment, Form, Button, Table, Loader, Popup, Icon } from 'semantic-ui-react';
import axios from 'axios';
import { Redirect } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import { fetchStudyType, fetchStudentStatuses } from '../../Lookups/util';
import { HeaderCursor } from '../../Professor/ProfessorInputGrades/css';


export default class FilterStudentsForCommitteeExam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            index: '',

            student: null,

            studentStatuses: [],
            studyTypes: [],
            filterData: [],

            loading: false,
            showStudentInfo: false

        };

        this.showStudent = this.showStudent.bind(this);
    }


    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        window.localStorage.clear();
        localStorage.setItem('activeRole', activeRole);
        if (!this.props.cancelGrade && this.props.location.state) {
            if (this.props.location.state.added) {
                toast('Komisijski ispit je uspješno kreiran.');
            }
        }

        axios.all([fetchStudyType(), fetchStudentStatuses()])
            .then(axios.spread((typesRes, statusesRes) => {
                const studyTypes = typesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.displayName
                }));
                let studentStatuses = statusesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }
                this.setState({
                    studyTypes, studentStatuses
                });
            }))
            .catch(err => {
                console.log('Failed to fetch study types or student statuses');
            });
    }

    showStudent() {
        const { firstName, lastName, index } = this.state;

        this.setState({ loading: false });

        if (!firstName && !lastName && !index) {
            toast('Morate unijeti bar jedan filter.');
            return;
        }

        let docFilter = {};

        if (firstName) docFilter = { ...docFilter, firstName };
        if (lastName) docFilter = { ...docFilter, lastName };
        if (index) docFilter = { ...docFilter, index };


        axios.post('students/filter-students-by-organizational-unit', { ...docFilter })
            .then(res => {
                const filterData = res.data.map(el => ({
                    ...el,
                    studyType: el.studyTypeId ? this.state.studyTypes.find(e => e.id === el.studyTypeId).name : null,
                    studentStatus: el.studentStatusId ? this.state.studentStatuses.find(e => e.id === el.studentStatusId).name : null
                }));
                this.setState({ filterData, loading: true });
            })
            .catch(err => {
                console.log('Failed to fetch filter results');
            });
    }


    render() {
        if (this.state.showStudentInfo === true) {
            return <Redirect push to={{ pathname: !this.props.cancelGrade ? '/komisijski-ispiti/poništavanje-ocjena' : '/studenti/poništavanje-ocjena', state: { student: this.state.student } }} />;
        }

        const { cancelGrade } = this.props;
        return (
            <div >

                {cancelGrade ? <h1>Poništavanje ocjena</h1> :
                    <h1>Komisijski ispiti</h1>}
                <Segment.Group raised>

                    <Segment>
                        <h3>Filtriranje studenata</h3>
                    </Segment>
                    <Segment clearing>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Ime</label>
                                    <input
                                        value={this.state.firstName}
                                        onChange={(e) => this.setState({ firstName: e.target.value })}
                                        name="firstName"
                                        placeholder="Unesite ime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Prezime</label>
                                    <input
                                        value={this.state.lastName}
                                        onChange={(e) => this.setState({ lastName: e.target.value })}
                                        name="lastName"
                                        placeholder="Unesite prezime"
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <label>Broj indexa</label>
                                    <input
                                        value={this.state.index}
                                        onChange={(e) => this.setState({ index: e.target.value })}
                                        name="index"
                                        placeholder="Unesite index"
                                    />
                                </Form.Field>

                            </Form.Group>

                            <Button floated="right" color="blue" onClick={this.showStudent}>Prikaži studenta</Button>
                        </Form>


                        {this.state.loading ?
                            <div>
                                <br />
                                <br />
                                { this.state.filterData.length ? <Table celled selectable compact >
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Prezime i ime</Table.HeaderCell>
                                            <Table.HeaderCell>Broj indexa</Table.HeaderCell>
                                            <Table.HeaderCell>Odsjek</Table.HeaderCell>
                                            <Table.HeaderCell>Studijski program</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body> {this.state.filterData.map((el, index) =>
                                        (<Popup
                                            trigger={<Table.Row key={index} style={HeaderCursor} onClick={() => { localStorage.setItem('student', JSON.stringify(el)); this.setState({ student: el, showStudentInfo: true }); }}>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.lastName} {el.firstName}  {el.locked === 1 ? <span style={{ float: 'right' }}> <Icon name="lock" color="blue" /></span> : null}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.index}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.departments.map(e => (<div>{e.name} <br /></div>))}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.studyProgramName}
                                                </Table.Cell>
                                            </Table.Row>}
                                            content="Poništavanje ocjena / kreiranje ispita"
                                            hideOnScroll
                                            position="left center"
                                        />))}
                                    </Table.Body>
                                </Table>
                                    : 'Nema studenata.'}
                            </div>

                            : <Loader />}
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/FilterStudentsForCommitteeExam.js